import { Box, Typography, SpeedDial, useMediaQuery, Button, Container, ToggleButtonGroup, ToggleButton, Badge } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useNavigate, useSearchParams } from 'react-router'
import Kanban from '../../components/kanban'
import { useTaskContext } from '../../../shared/context/taskContext'
import { useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles'
import { useUtiles } from '../../../shared/context/utilesContext'
import { useAbility } from '../../../shared/context/AbilityContext'

import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import Calendar from '../../components/calendar'
import FilterListIcon from '@mui/icons-material/FilterList';
import FiltersKanbanComponent from '../components/filtersKanbanComponent'
import {
    parseKanbanFiltersFromSearchParams,
    saveKanbanFiltersToStorage,
    buildKanbanTasksRequest,
    hasActiveKanbanFilters,
} from '../utils/kanbanFilters'

export default function TaskListView() {

    const ability = useAbility();
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const theme = useTheme()
    const isMobile = useMediaQuery('(max-width: 600px)')
    const {
        tasks,
        loadingTasks,
        getTasks,
        selectedTaskPending,
        setOtWithTaskPending,
        setSelectedTaskPending,
        resetTask,
        setIsUpdateTask,
        setFiltersKanban,
    } = useTaskContext()
    const { toogleOpenSilder } = useUtiles()

    const [viewTab, setViewTab] = useState(searchParams.get('view') || 'kanban')
    const filtersActive = hasActiveKanbanFilters(searchParams)

    useEffect(() => {
        setViewTab(searchParams.get('view') || 'kanban')
    }, [searchParams.get('view')])

    const handleViewTab = (event, newValue) => {
        if (newValue !== null) {
            setViewTab(newValue);
            const nextParams = new URLSearchParams(searchParams)
            if (newValue === 'kanban') {
                nextParams.delete('view')
            } else {
                nextParams.set('view', newValue)
            }
            setSearchParams(nextParams, { replace: true })
            saveKanbanFiltersToStorage(nextParams)
        }
    }

    useEffect(() => {
        const parsedFilters = parseKanbanFiltersFromSearchParams(searchParams)
        setFiltersKanban(parsedFilters)
        getTasks(buildKanbanTasksRequest(parsedFilters))
        setSelectedTaskPending([])
        setIsUpdateTask(false)
        saveKanbanFiltersToStorage(searchParams)
    }, [searchParams.toString()])


    const handleCreateOTWithTasks = () => {
        if (selectedTaskPending.length > 0) {
            setOtWithTaskPending(prev => ({ ...prev, task_list: selectedTaskPending }))
            navigate('/task/wo/create-ot')
        }
    }


    const handleCreateTask = () => {
        resetTask()
        navigate('/task/wo/create')
    }

    const handleFilters = () => {
        toogleOpenSilder(
            <FiltersKanbanComponent setSearchParams={setSearchParams} />,
            400,
            'Filtros'
        )
    }


    useEffect(() => {
        if (!ability.can('read', 'TASK') && !ability.can('read', 'OTS')) {
            navigate('/')
        }
    }, [ability])

    return (
        <Container maxWidth="xl" disableGutters sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: { xs: 2, sm: 3 },
                py: 2,
                width: '100%',
                flexShrink: 0
            }}>

                <ToggleButtonGroup
                    value={viewTab}
                    onChange={handleViewTab}
                    color="primary"
                    variant="contained"
                    exclusive
                    size="small"
                    sx={{
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.secondary,
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: theme.palette.background.paper,
                            color: theme.palette.text.primary,
                        },
                        '&.Mui-selected': {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                        }
                    }}
                >
                    <ToggleButton value={"kanban"} >
                        <ViewKanbanOutlinedIcon sx={{ mr: { xs: 0, sm: 1 } }} />  { !isMobile ? 'Kanban' : ''}
                    </ToggleButton>
                    <ToggleButton value={"calendar"} >
                        <CalendarMonthOutlinedIcon sx={{ mr: { xs: 0, sm: 1 } }} /> { !isMobile ? 'Calendario' : ''}
                    </ToggleButton>
                </ToggleButtonGroup>


                {selectedTaskPending.length > 0 && <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Tareas seleccionadas ({selectedTaskPending.length})
                </Typography>}

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                }}>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={selectedTaskPending.length === 0}
                    onClick={handleCreateOTWithTasks}
                    startIcon={<AddIcon />}
                    sx={{ backgroundColor: theme.palette.primary.main }}
                >
                    Nueva OT
                </Button>

               { viewTab === 'kanban' && <Badge
                    color="primary"
                    variant="dot"
                    invisible={!filtersActive}
                    overlap="circular"
                >
                    <Button
                        variant={filtersActive ? 'contained' : 'outlined'}
                        color="primary"
                        startIcon={<FilterListIcon />}
                        sx={{
                            backgroundColor: filtersActive
                                ? theme.palette.primary.main
                                : theme.palette.background.paper,
                        }}
                        onClick={handleFilters}
                    >
                        Filtros
                    </Button>
                </Badge>}

                </Box>
            </Box>

            <Box sx={{
                flex: 1,
                px: { xs: 0, sm: 1 },
                minHeight: 0,
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {viewTab === 'kanban' && <Kanban tasks={tasks} loadingTasks={loadingTasks} />}
                {viewTab === 'calendar' && <Calendar tasks={tasks} />}
            </Box>

            {selectedTaskPending.length === 0 && ability.can('create', 'TASK') && <SpeedDial
                ariaLabel="Add"
                sx={{ position: 'fixed', bottom: isMobile ? 40 : 30, right: 8 }}
                icon={<AddIcon />}
                direction="right"
                openIcon={<AddIcon />}
                onClick={handleCreateTask}
            />}
        </Container>
    )
}
